var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#273F3B"
  })));
};

export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE0QzEzLjEwNDYgMTQgMTQgMTMuMTA0NiAxNCAxMkMxNCAxMC44OTU0IDEzLjEwNDYgMTAgMTIgMTBDMTAuODk1NCAxMCAxMCAxMC44OTU0IDEwIDEyQzEwIDEzLjEwNDYgMTAuODk1NCAxNCAxMiAxNFoiIGZpbGw9IiMyNzNGM0IiLz4KPHBhdGggZD0iTTEyIDIxQzEzLjEwNDYgMjEgMTQgMjAuMTA0NiAxNCAxOUMxNCAxNy44OTU0IDEzLjEwNDYgMTcgMTIgMTdDMTAuODk1NCAxNyAxMCAxNy44OTU0IDEwIDE5QzEwIDIwLjEwNDYgMTAuODk1NCAyMSAxMiAyMVoiIGZpbGw9IiMyNzNGM0IiLz4KPHBhdGggZD0iTTEyIDdDMTMuMTA0NiA3IDE0IDYuMTA0NTcgMTQgNUMxNCAzLjg5NTQzIDEzLjEwNDYgMyAxMiAzQzEwLjg5NTQgMyAxMCAzLjg5NTQzIDEwIDVDMTAgNi4xMDQ1NyAxMC44OTU0IDcgMTIgN1oiIGZpbGw9IiMyNzNGM0IiLz4KPC9zdmc+Cg==";